module.exports = __webpack_public_path__ + "static/media/Ghidra-logo.614689d9.png";